export default "__VITE_ASSET__TKRJSBd4__"